import React, { useEffect } from "react";
import { useState } from "react";
import { FaQuestionCircle } from "react-icons/fa";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { IoMdClock } from "react-icons/io";
import { preventDefault } from "@fullcalendar/core/internal";

export default () => {
  const [reqType, setReqType] = useState([]);
  const [requests, setRequest] = useState([]);
  const [availability, setAvailability] = useState("");
  const [Loading, setLoading] = useState(false);
  const [requestDetails, setRequestDetails] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [sort, setsort] = useState("");
  const [filter, setfilter] = useState("");

  const requestResponse = useApi((dataToSend) =>
    apiClient.post("/request/request-responses/", dataToSend)
  );

  const handleRequestResponse = async (id, type) => {
    const dataToSend = {
      requestId: id,
      approve_decline: type === "accept" ? true : false,
      // availability_time_str: availability,
    };
    const res = await requestResponse.request(dataToSend);

    toast.error(res.data.error);
  };

  // const { request, loading, error } = useApi((resultData) =>
  //   apiClient.post("/vehicleRequest", resultData)
  // );

  const fetch = async () => {
    const res = await apiClient.get("/request/request-types/");
    if (res.ok) {
      setReqType(res.data);
    }
  };
  const fetchRequestList = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();

      // Add parameters
      if (filter) params.append("request_type", filter);
      if (sort) params.append("order", sort);

      // Convert to string and append to a URL
      const urlString = "/request/request-list/?" + params.toString();
      const res = await apiClient.get(urlString);

      if (res.ok) {
        setRequest(res.data);
        console.log(res.data, "ccc");
      } else {
        console.error(`Error fetching data: ${res.status} - ${res.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // const photoRequests = [
  //   {
  //     dateTime: "12/15/2022; 1:00pm",
  //     location: "Sofi Stadium, Inglewood, CA",
  //     earnings: "$450.00",
  //     buttonText: "Removal",
  //     image: require("../../assets/img/removalGray.png"),
  //   },

  //   {
  //     dateTime: "12/16/2022; 2:00pm",
  //     location: "Madison Square Garden,",
  //     earnings: "$600.00",
  //     buttonText: "Photoshoot",
  //     image: require("../../assets/img/cameraGray.png"),
  //   },
  //   {
  //     dateTime: "12/16/2022; 2:00pm",
  //     location: "Madison Square Garden,",
  //     earnings: "$600.00",
  //     buttonText: "Install",
  //     image: require("../../assets/img/installGray.png"),
  //   },
  //   {
  //     dateTime: "12/15/2022; 1:00pm",
  //     location: "Sofi Stadium, Inglewood, CA",
  //     earnings: "$450.00",
  //     buttonText: "Removal",
  //     image: require("../../assets/img/removalGray.png"),
  //   },
  // ];
  useEffect(() => {
    fetchRequestList();
  }, [sort, filter]);

  useEffect(() => {
    fetch();
  }, []);
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const resultData = {
  //     request_type: reqType,
  //     message: requests.message,
  //   };
  //   const result = await request(resultData);
  //   if (result.status === 200) {
  //     toast.success("Account Succesfully Created");
  //   } else {
  //     toast.error("Error");
  //   }
  // };
  console.log(filter, "qqq");

  const sortfung = (data) => {
    setsort(data);
  };
  const filterfung = (data) => {
    setfilter(data);
  };

  return (
    <div  className=" zoom">
      <div className="site-content h-100">
        <div className="p-1">
          <div className="site-content-body">
            <div className="position-relative">
              {/*-----------Start || Payment section---------*/}
              <section className="req-sec main-sec border py-3">
                <div className="container">
                  <form>
                    {/* ----------Request textarea--------- */}
                    <div className="row " style={{ cursor: "pointer" }}>
                      <Box className="col-md-2 col-6 mt-1 list-group">
                        <div class="dropdown " style={{ width: "120px" }}>
                          <button
                            class="w-100 btn dropdown-toggle fw-bold w-50 text-center list-group-item-action active"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{
                              backgroundColor: "white",
                              color: "#015A96",
                              borderRadius: "15px",
                            }}
                          >
                            Sort
                          </button>
                          <ul
                            class="dropdown-menu p-2 fw-bold"
                            style={{ color: "#015A96" }}
                          >
                            <li
                              type="button"
                              className="list-group-item list-group-item-action"
                              onClick={() => sortfung("newest")}
                            >
                              Newest
                            </li>
                            <li
                              type="button"
                              className="list-group-item list-group-item-action"
                              onClick={() => sortfung("oldest")}
                            >
                              Oldest
                            </li>
                          </ul>
                        </div>
                      </Box>
                      <Box
                        sx={{ display: { sm: "inline-block", xs: "none" } }}
                        className="col-sm-8 mt-1"
                      >
                        <h5
                          className="col-lg-8 m-0 mt-auto mb-1 mx-auto text-center"
                          style={{ color: "#015A96" }}
                        >
                          Current Requests
                        </h5>
                      </Box>

                      <Box className="col-md-2  col-6 mt-1 list-group">
                        <div class="dropdown  ms-auto" style={{ width: "120px" }}>
                          <button
                            class="w-100 btn dropdown-toggle  fw-bold w-50 text-center list-group-item-action active"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{
                              backgroundColor: "white",
                              color: "#015A96",
                              borderRadius: "15px",
                            }}
                          >
                            Filter
                          </button>
                          <ul
                            class="dropdown-menu p-2 fw-bold"
                            style={{ color: "#015A96" }}
                          >
                            {reqType?.map((item, index) => (
                              <button
                                onClick={() => filterfung(item.id)}
                                type="button"
                                className="list-group-item  list-group-item-action"
                                key={item.id}
                              >
                                {item.request_type}
                              </button>
                            ))}
                            {/* <li
                              type="button"
                              className="list-group-item list-group-item-action"
                              onClick={()=>sortfung("newest")}
                            >
                              Newest
                            </li>
                            <li
                              type="button"
                              className="list-group-item list-group-item-action"
                              onClick={()=>sortfung("oldest")}
                            >
                              Oldest
                            </li> */}
                          </ul>
                        </div>
                      </Box>
                    </div>
                    <Box
                      sx={{ display: { sm: "none", xs: "flex" } }}
                      className="justify-centent-center"
                    >
                      <h5
                        className="col-lg-8 m-0 mt-auto mb-1 mx-auto text-center"
                        style={{ color: "#015A96" }}
                      >
                        Current Requests
                      </h5>
                    </Box>
                    <Box
                      sx={{ display: { sm: "none", xs: "block" } }}
                      className="my-hr my-3 mx-auto mt-0 mb-4"
                    />
                    <Box
                      sx={{ display: { sm: "block", xs: "none" } }}
                      className="my-hr my-3 mx-auto mt-0 mb-4"
                    />
                    {/* ----------Request view--------- */}
                    {!Loading ? (
                      <div className="">
                        {requests.map((request, index) => {
                          console.log(request, "req");

                          return (
                            <div className=" d-sm-flex make_res mt-4  " >
                              <div
                                className="  req-field d-flex  align-items-center w-100 h-100"
                                key={index}
                              >
                                <div className="req-btn d-flex align-items-center justify-content-center ps-2 grey-txt gr-btn mb-xl-0 ">
                                  <img
                                    src={
                                      request.icon_url
                                      // reqType?.find(
                                      //   (item). => item.id === request.request_type
                                      // )?.icon_url
                                    }
                                    className="img-fluid"
                                    width="20px"
                                    alt=""
                                  />
                                  <button
                                    onClick={(e) => e.preventDefault()}
                                    className="py-3  grey-txt  "
                                  >
                                    {
                                      request.request_type
                                      
                                    }
                                  </button>
                                </div>

                                <div
                                  className=" d-flex p-1 align-items-center justify-content-between blue-txt w-100 bg-white req-fix"
                                  style={{ cursor: "pointer" }}
                                >
                                  <div
                                    className={`
                                  
                              }`}
                                  >
                                    <p 
                                      className="blue-txt mb-0 req_font  bs-lh "
                                     
                                    >
                                      Date/Time: {request.date_time}
                                    </p>
                                    <p
                                      className="blue-txt mb-0 req_font bs-lh"
                                      
                                    >
                                      Location: {request.address}
                                    </p>
                                    {/* <p
                                className="blue-txt mb-0  bs-lh"
                                style={{ fontSize: "14px" }}
                              >
                                Estimated Earnings: {request.estimated_earnings}
                              </p> */}
                                  </div>
                                  <div className="d-flex flex-column align-items-center justify-content-center ps-2">
                                    {/* <div
                                className=" test border-bottom d-flex align-items-center  position-relative  req-link justify-content-between"
                                onClick={() => {
                                  setShow(true);
                                }}
                              >
                                <p className="blue-txt my-auto ">
                                    
                                </p>
                                <IoMdClock style={{ fontSize: "26px" }} />
                              </div> */}
                                    <div
                                      className="   d-flex align-items-center req-link  justify-content-between"
                                      style={{ padding: "13px 0 13px 0" }}
                                      onClick={() => {
                                        setModalShow(true);
                                        setRequestDetails(request);
                                      }}
                                    >
                                      <p className="blue-txt text-nowrap  my-auto">
                                        See Details
                                      </p>
                                      <img
                                        src={require("../../assets/img/attach-f.png")}
                                        alt="Doc"
                                        className="p-1  calendar-icon"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="d-md-block d-none">
                            {request?.request_type == "Other" ? (
                                  <div
                                    className="ms-xl-2 d-flex justify-content-end req-btns mt-2  mt-xl-0 pad"
                                    style={{ minWidth: "200px" }}
                                  >
                                    <a
                                      onClick={() =>
                                        handleRequestResponse(
                                          request.id,
                                          "accept"
                                        )
                                      }
                                      href="#"
                                      type="submit"
                                      className="d-flex align-items-center justify-content-center blue-txt bg-white w-50"
                                    >
                                      Accept
                                    </a>
                                    <a
                                      onClick={() =>
                                        handleRequestResponse(
                                          request.id,
                                          "deny"
                                        )
                                      }
                                      href="#"
                                      className="d-flex align-items-center justify-content-center blue-txt bg-white w-50"
                                    >
                                      Deny
                                    </a>
                                  </div>
                                ) : (
                                  <div
                                    className="ms-xl-2 d-flex justify-content-end req-btns mt-2  mt-xl-0 pad"
                                    style={{ minWidth: "200px" }}
                                  >
                                    <a
                                      href="#"
                                      type="submit"
                                      className="d-flex align-items-center justify-content-center blue-txt bg-white w-100"
                                    >
                                      Scheduled
                                    </a>
                                  </div>
                                )}
                                </div>
                               
                              </div>

                              <div className="d-md-none d-block">
                            {request?.request_type == "Other" ? (
                                  <div
                                    className="ms-xl-2 d-flex justify-content-end req-btns mt-2  mt-xl-0 pad"
                                    style={{ minWidth: "200px" }}
                                  >
                                    <a
                                      onClick={() =>
                                        handleRequestResponse(
                                          request.id,
                                          "accept"
                                        )
                                      }
                                      href="#"
                                      type="submit"
                                      className="d-flex align-items-center justify-content-center blue-txt bg-white w-50"
                                    >
                                      Accept
                                    </a>
                                    <a
                                      onClick={() =>
                                        handleRequestResponse(
                                          request.id,
                                          "deny"
                                        )
                                      }
                                      href="#"
                                      className="d-flex align-items-center justify-content-center blue-txt bg-white w-50"
                                    >
                                      Deny
                                    </a>
                                  </div>
                                ) : (
                                  <div
                                    className="ms-xl-2 d-flex justify-content-end req-btns mt-2  mt-xl-0 pad"
                                    style={{ minWidth: "200px" }}
                                  >
                                    <a
                                      href="#"
                                      type="submit"
                                      className="d-flex align-items-center justify-content-center blue-txt bg-white w-100"
                                    >
                                      Scheduled
                                    </a>
                                  </div>
                                )}
                                </div>
                              <hr />
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center mt-3">
                        <h1>
                          {" "}
                          <CircularProgress />
                        </h1>
                      </div>
                    )}{" "}
                    <div>
                      {/* modal body  */}
                      <Modal show={show} onHide={handleClose}>
                        {/* <Modal.Header closeButton>
                                <Modal.Title></Modal.Title>
                              </Modal.Header> */}
                        <Modal.Body>
                          <h5 className="text-center p-2">
                            Select Date and Time
                          </h5>
                          {/* <RangeDatePicker/> */}
                          <div>
                            <label className="p-2" htmlFor="time">
                              Date&Time
                            </label>
                            <input
                              className="form-control"
                              type="datetime-local"
                              name=""
                              id="time"
                              onChange={(e) => setAvailability(e.target.value)}
                              value={availability}
                            />
                          </div>
                          {/* <div className='mt-3'>
                                    <label className='p-2' htmlFor="date">Date</label>
                                    <input className='form-control' type="date" name="" id="date" />
                                    </div> */}
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={handleClose}>
                            Close
                          </Button>
                          <Button variant="primary" onClick={handleClose}>
                            Save Changes
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </form>
                </div>
              </section>
              {/*-----------------------------
                                  End || Payment section
                              ----------------------------- */}
            </div>
          </div>
        </div>
      </div>
      <Detail
        data={requestDetails}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </div>
  );
};

function Detail(props) {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {/* <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          All Details
        </Modal.Title>
      </Modal.Header> */}
      <Modal.Body>
        <h5 style={{ color: "#015A96" }}>Details:</h5>
        <p>{props.data.description}</p>
        <h5 style={{ color: "#015A96" }}>Location:</h5>
        <p>{props.data.address}</p>

        {/* <h5 style={{ color: "#015A96" }}>Sent By:</h5>
        <p>{props.data.SentBy}</p> */}
        <h5 style={{ color: "#015A96" }}>Start Date:</h5>
        <p>{props.data.start_date}</p>
        <h5 style={{ color: "#015A96" }}>Start Time:</h5>
        <p>{props.data.start_time}</p>
        <h5 style={{ color: "#015A96" }}>End Date:</h5>
        <p>{props.data.end_date}</p>
        <h5 style={{ color: "#015A96" }}>End Time:</h5>
        <p>{props.data.end_time}</p>
        {/* <h5 style={{ color: "#015A96" }}>State:</h5>
        <p>{props.data.state}</p> */}
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={() => props.onHide()}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
}
